export default "__VITE_PUBLIC_ASSET__e18573db__"